import { render, staticRenderFns } from "./edit-applicant-link.vue?vue&type=template&id=428957ec"
import script from "./edit-applicant-link.vue?vue&type=script&lang=js"
export * from "./edit-applicant-link.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports